import React from "react";
import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui icons
import Dashboard from "mdi-material-ui/DesktopMacDashboard";
import GroupWork from "@material-ui/icons/GroupWork";
import CalendarClock from "mdi-material-ui/CalendarClock";

// core components
import GridContainer from "components/GridContainer.jsx";
import GridItem from "components/GridItem.jsx";
import InfoArea from "components/InfoArea.jsx";

import { section, mrAuto, mlAuto, title, container, description } from "assets/jss/material-kit-pro-react.jsx";

const useStyle = makeStyles(theme => ({
  mrAuto,
  mlAuto,
  title,
  container,
  description: {
    ...description,
    color: "#646464",
    fontSize: "1.1em",
  },
  section: {
    ...section,
    padding: "0px 0px",
  },
  features: {
    ...section,
    backgroundRepeat: "no-repeat",
    position: "relative",
    padding: "40px 0px",
    textAlign: "center",
    "& $title": {
      zIndex: "2",
      position: "relative",
      marginBottom: "16px",
    },
    "& $description": {
      zIndex: "2",
      position: "relative",
      marginBottom: "48px",
    },
    "&:after": {
      background: "#F7F9FA",
      position: "absolute",
      width: "100%",
      height: "100%",
      content: "''",
      zIndex: "0",
      left: "0px",
      top: "0px",
    },
  },
  featuresShow: {
    zIndex: 3,
    "& h2": {
      fontSize: 24,
    },
    "& p": {
      marginTop: 16,
      lineHeight: "24px",
      fontSize: "16px",
    },
  },
  infoArea: {
    padding: "0 0.75em",
    border: "1px solid transparent",
    "& p": {
      color: "#646464",
      fontSize: "1.1em"
    },
    "& p:hover": {
      color: "#323232",
    },
    "&:hover": {
      border: "1px solid #899db2",
    },
    margin: "0 1.5em",
  },
}));

const SectionOverview = props => {
  const { ...rest } = props;
  const classes = useStyle();
  return (
    <div className="cd-section" {...rest}>
      <div className={classes.section}>
        <div className={classes.features}>
          <GridItem md={8} className={classNames(classes.mlAuto, classes.mrAuto)}>
            <h2 className={classes.title}>Why OptaPlan?</h2>
            <p className={classes.description}>Get organized, stay on track, and ship on time.</p>
          </GridItem>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem sm={4} className={classes.featuresShow}>
                <InfoArea
                  className={classes.infoArea}
                  title="Birds eye-view of all orders"
                  description={<p>Get full visibility of orders across buyers and teams in the Organization.</p>}
                  icon={Dashboard}
                  iconColor="primary"
                  vertical={true}
                />
              </GridItem>
              <GridItem sm={4} className={classes.featuresShow}>
                <InfoArea
                  className={classes.infoArea}
                  title="Collaboration among departments"
                  description={<p>Move from merchant centric TNA management to a collaborative working.</p>}
                  icon={GroupWork}
                  iconColor="primary"
                  vertical={true}
                />
              </GridItem>
              <GridItem sm={4} className={classes.featuresShow}>
                <InfoArea
                  className={classes.infoArea}
                  title="Never miss a deadline, deliver on time"
                  description={<p>Follow orders and activities through every stage and take control of timeline.</p>}
                  icon={CalendarClock}
                  iconColor="primary"
                  vertical={true}
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOverview;
